import React, { ReactNode } from 'react'

export type SubHeadingProps = {
  children: ReactNode
}

export const SubHeading = ({ children }: SubHeadingProps) => (
  <div className="frw-heading--sub">{children}</div>
)
export default SubHeading
